<div class="overflow-container" [ngClass]="{ 'scrollbar-at-top': showScrollbarAtTop }">
    <sew-table class="sew-theme-inverted">
        <table
            cdk-table
            [dataSource]="displayItems | tableFilter: (filters | async) | tableSort: (sorter | async)"
            [trackBy]="trackBy"
            [multiTemplateDataRows]="true"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
            [cdkDropListData]="displayItems"
            [cdkDropListDisabled]="!dragEnabled"
            (contentChanged)="applyTableHeaderTheme()"
        >
            <ng-container cdkColumnDef="checkbox">
                <th cdk-header-cell *cdkHeaderCellDef>
                    <sew-checkbox>
                        <input
                            type="checkbox"
                            [checked]="isCheckAllChecked()"
                            [disabled]="isCheckAllDisabled()"
                            [indeterminate]="isCheckAllIndeterminate()"
                            (change)="$event.isTrusted && toggleAllChecked($any($event.target).checked)"
                        />
                    </sew-checkbox>
                </th>
                <td cdk-cell *cdkCellDef="let row; let i = dataIndex" class="td-checkbox-row">
                    @if (isSelectableRow(row)) {
                        <sew-checkbox>
                            <input
                                type="checkbox"
                                [disabled]="isRowSelectionDisabled(row)"
                                [checked]="isRowChecked(row)"
                                [indeterminate]="isGroupHeaderPartiallySelected(row)"
                                (click)="$event.stopPropagation()"
                                (change)="
                                    $event.isTrusted && toggleRowChecked(row, $any($event.target).checked)
                                "
                            />
                        </sew-checkbox>
                    }
                </td>
            </ng-container>

            <ng-container cdkColumnDef="collapse">
                <td cdk-cell *cdkCellDef="let row; let i = dataIndex">
                    <sew-button
                        [icon]="row.isOpen ? 'arrow-chevron-down' : 'arrow-chevron-right'"
                        hierarchy="tertiary"
                        size="xs"
                        show-icon-only
                    >
                        <button (click)="row.isOpen = !row.isOpen"></button>
                    </sew-button>
                </td>
            </ng-container>

            <ng-container cdkColumnDef="expand-toggle">
                <th cdk-header-cell *cdkHeaderCellDef class="expand-toggle-header"></th>
                <td cdk-cell *cdkCellDef="let row; let i = dataIndex" class="expand-toggle-cell">
                    @if (isExpandableRow(i, row) && isValidExpandableRow(row)) {
                        <sew-button
                            [icon]="expandedRow === row ? 'arrow-chevron-down' : 'arrow-chevron-right'"
                            hierarchy="tertiary"
                            size="xs"
                            show-icon-only
                        >
                            <button (click)="$event.stopPropagation(); toggleExpand(row)"></button>
                        </sew-button>
                    }
                </td>
            </ng-container>

            <ng-container cdkColumnDef="edit">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let row; let i = dataIndex">
                    <sew-button icon="edit" hierarchy="tertiary" size="xs" show-icon-only>
                        <button (click)="editRowClicked(row)"></button>
                    </sew-button>
                </td>
            </ng-container>

            <tr cdk-header-row *cdkHeaderRowDef="displayColumns; sticky: false"></tr>

            <!-- changes in hide were needed due to the removal of the circular structure of the contained rows, including a reference to their groupRow (ciruclar) -->
            <tr
                cdk-row
                *cdkRowDef="let row; columns: displayColumns; when: showDefaultRow; let i = dataIndex"
                [oscTableScrollTarget]="row"
                class="default-row"
                [ngClass]="{
                    'category-item-row': row.isCategoryItemRow,
                    hide:
                        !!row.groupRow &&
                        !!groupItems[row.groupRow.rowData.uniqueGroupId] &&
                        !!$any(groupItems[row.groupRow.rowData.uniqueGroupId]).isCategoryHeaderRow &&
                        !$any(groupItems[row.groupRow.rowData.uniqueGroupId]).isOpen,
                    active: selectedRow === row && !hideMarkedBar,
                    filtered: $any(row).isFiltered,
                }"
                (click)="toggleRowMarked(row)"
                cdkDrag
                [cdkDragData]="row"
                cdkDragPreviewClass="custom-drag-preview"
            ></tr>

            <tr
                cdk-row
                *cdkRowDef="let row; columns: ['expandableRow']; when: isExpandableRow; let i = dataIndex"
                class="expandable-row"
                [ngClass]="{
                    hide:
                        (row.isCategoryItemRow &&
                            !!$any(groupItems[row.groupRow.rowData.uniqueGroupId]).isCategoryHeaderRow &&
                            !$any(groupItems[row.groupRow.rowData.uniqueGroupId]).isOpen) ||
                        expandedRow !== row,
                    filtered: $any(row).isFiltered,
                }"
                cdkDrag
                [cdkDragData]="row"
                cdkDragPreviewClass="custom-drag-preview"
            ></tr>

            <tr
                cdk-row
                *cdkRowDef="let row; columns: ['fullRowContent']; when: isFullRowContent; let i = dataIndex"
                class="child-full-row"
                cdkDrag
                [cdkDragData]="row"
                cdkDragPreviewClass="custom-drag-preview"
            ></tr>

            <tr
                cdk-row
                *cdkRowDef="
                    let row;
                    columns: displayGroupHeaderColumns;
                    when: isGroupHeaderRow;
                    let i = dataIndex
                "
                class="group-header-row"
                [ngClass]="{
                    filtered: $any(row).isFiltered,
                    active: selectedRow === row && !hideMarkedBar,
                }"
                (click)="toggleRowMarked(row)"
                cdkDrag
                [cdkDragData]="row"
                cdkDragPreviewClass="custom-drag-preview"
            ></tr>

            <tr
                cdk-row
                *cdkRowDef="
                    let row;
                    columns: categoryHeaderColumns;
                    when: isCategoryHeaderRow;
                    let i = dataIndex
                "
                class="group-header-row"
                [ngClass]="{
                    filtered: $any(row).isFiltered,
                }"
                cdkDrag
                [cdkDragData]="row"
                cdkDragPreviewClass="custom-drag-preview"
            ></tr>
        </table>
    </sew-table>
</div>

@if (actionBar) {
    <ng-container *ngTemplateOutlet="actionBar; context: { $implicit: checkedRows }"></ng-container>
}
